// import React from 'react';
// import styled from 'styled-components';
// import UserCreditModal from '../../Pages/Parts/User/WalletModal'

// const Container = styled.div`
//   background-color: #d35400;
//   color: white;
//   padding: 20px;
// `;

// const Header = styled.h1`
//   font-size: 24px;
//   margin-bottom: 5px;
// `;

// const Subheader = styled.h2`
//   font-size: 20px;
//   color: #ffd700;
//   margin-top: 0;
// `;

// const Description = styled.p`
//   font-size: 14px;
// `;

// const TiersContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, 1fr); /* 4 items per row for large screens */
//   gap: 20px;

//   @media (max-width: 1250px) {
//     grid-template-columns: repeat(3, 1fr); /* 3 items per row for medium screens */
//   }

//   @media (max-width: 997px) {
//     grid-template-columns: repeat(2, 1fr); /* 2 items per row for tablet screens */
//   }

// `;

// const TierCard = styled.div`
//   width: 100%;
//   border-radius: 10px;
//   padding: 10px;
//   position: relative;
// `;

// const TierImage = styled.div`
//   width: 100%;
//   height: auto;
//   border-radius: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   // margin-bottom: 40px;
//   position: relative;
//   flex-direction:column;
// `;

// const DepositButton = styled.button`
//   // position: absolute;
//   // top: 250px;
//   // left: 50%;
//   // transform: translateX(-50%);
//   background-color: ${props => props.isFirst ? '#ffd700' : 'gray'};
//   color: ${props => props.isFirst ? 'black' : 'white'};
//   border: none;
//   padding: 8px 16px;
//   margin-top:10px;
//   border-radius: 20px;
//   cursor: pointer;
//   opacity: ${props => props.isFirst ? 1 : 0};
//   transition: opacity 0.3s;
//   ${TierImage}:hover & {
//     opacity: 1;
//   }
// `;

// const Card = styled.div`
//   background: linear-gradient(135deg, #00925D 0%, #1E3B4D 100%);
//   border-radius: 12px;
//   padding: 24px;
//   color: white;
//   width: 100%;
//   margin-top: 12px;
// `;

// const Title = styled.h2`
//   font-size: 24px;
//   font-weight: bold;
//   margin: 0;
//   text-transform: uppercase;
// `;

// const Subtitle = styled.p`
//   font-size: 14px;
//   margin: 4px 0 40px 0;
//   opacity: 0.9;
// `;

// const BottomRow = styled.div`
//   display: flex;
//   justify-content: space-around;
//   align-items: center;
// `;

// const Details = styled.div`
//   display: flex;
//   align-items: center;
//   font-size: 14px;

//   &::after {
//     content: '›';
//     margin-left: 4px;
//   }
// `;

// const ProgressText = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-left: auto;
//   font-size: 12px;
//   opacity: 0.7;
// `;

// const MedalText = styled.div`
//   text-align: center;

//   span {
//     display: block;
//     &:last-child {
//       opacity: 0.7;
//     }
//   }
// `;

// class Promotions extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       tiers: [
//         { color: '#f39c12', title: 'First Deposit', bonus: '180%', src: '/assets/images/promo/promo-1.png' },
//         { color: '#e67e22', title: 'Second Deposit', bonus: '240%', src: '/assets/images/promo/promo-2.png' },
//         { color: '#9b59b6', title: 'Third Deposit', bonus: '300%', src: '/assets/images/promo/promo-3.png' },
//         { color: '#8e44ad', title: 'Fourth Deposit', bonus: '360%', src: '/assets/images/promo/promo-4.png' },
//       ],
//       showWalletModal: false,
//       showCurrencyModal: false,
//       activeSection: 'deposit',
//     };
//   }

//   render() {
//     return (
//       <div style={{ marginTop: '20px' }}>
//         <Container>
//           <Header>GREAT BONUS FOR EVERY DEPOSIT</Header>
//           <Subheader>PPD UNLOCK SPEED +5%</Subheader>
//           <Description>Available for all players</Description>
//           <TiersContainer>
//             {this.state.tiers.map((tier, index) => (
//               <TierCard key={index} color={tier.color}>
//                 <TierImage>
//                   <img className='promotions-image' src={tier.src} style={{ borderRadius: '18px', width: '100%' }} alt={`Tier ${index + 1}`} />
//                   <DepositButton onClick={() => this.setState({ showWalletModal: true })} isFirst={index === 0}>
//                     Deposit Now
//                   </DepositButton>
//                 </TierImage>
//               </TierCard>
//             ))}
//           </TiersContainer>
//         </Container>

//         <Card>
//           <Title>Master Medals</Title>
//           <Subtitle>Witness every step of your becoming a Master</Subtitle>
//           <BottomRow>
//             <Details>Details</Details>
//             <ProgressText>
//               <MedalText>
//                 <span>0</span>
//                 <span>Medals</span>
//               </MedalText>
//               <MedalText>
//                 <span>5</span>
//                 <span>Medals</span>
//               </MedalText>
//               <MedalText>
//                 <span>10</span>
//                 <span>Medals</span>
//               </MedalText>
//               <MedalText>
//                 <span>15</span>
//                 <span>Medals</span>
//               </MedalText>
//               <MedalText>
//                 <span>Max</span>
//               </MedalText>
//             </ProgressText>
//           </BottomRow>
//         </Card>

//         <UserCreditModal
//           showWalletModal={this.state.showWalletModal}
//           showCurrencyModal={this.state.showCurrencyModal}
//           activeSection={this.state.activeSection}
//           onToggleWalletModal={() => this.setState(prevState => ({ showWalletModal: !prevState.showWalletModal }))}
//           onToggleCurrencyModal={() => this.setState(prevState => ({ showCurrencyModal: !prevState.showCurrencyModal }))}
//           onSetActiveSection={sectionId => this.setState({ activeSection: sectionId })}
//         />
//       </div>
//     );
//   }
// }

// export default Promotions;

import React, { useEffect, useState } from "react";
import "./Promotions.css";
import CardPromotion from "./CardPromotion";
import CardArchivePromotion from "./CardArchivePromotion";
import DepositUpi from "../../Pages/Payment/DepositUpi";
import { border, fontWeight, style } from "@mui/system";
import { color } from "highcharts";
import axios from "axios";
import { getUID } from "../../../Helper";
import Cookies from "js-cookie";

function Promotions() {
  const [activeTab, setActiveTab] = useState("Latest Promotion");

  // Dynamic data for the promotion cards
  const promotions = [
    {
      rank: "01",
      bonus: "120% BONUS",
      description: "First Deposit",
      imgSrc: "/assets/bcimages/promotion/box1.webp",
      bgImgSrc: "/assets/bcimages/promotion/backimg1.webp",
    },
    {
      rank: "02",
      bonus: "100% BONUS",
      description: "Second Deposit",
      imgSrc: "/assets/bcimages/promotion/box2.webp",
      bgImgSrc: "/assets/bcimages/promotion/backimg2.png",
    },
    {
      rank: "03",
      bonus: "150% BONUS",
      description: "Third Deposit",
      imgSrc: "/assets/bcimages/promotion/box3.webp",
      bgImgSrc: "/assets/bcimages/promotion/backimg3.png",
    },
    {
      rank: "04",
      bonus: "100% BONUS",
      description: "Fourth Deposit",
      imgSrc: "/assets/bcimages/promotion/box4.webp",
      bgImgSrc: "/assets/bcimages/promotion/backimg4.png",
    },
    {
      rank: "5",
      bonus: "100% BONUS",
      description: "Fourth Deposit",
      imgSrc: "/assets/bcimages/promotion/box4.webp",
      bgImgSrc: "/assets/bcimages/promotion/backimg4.png",
    },
  ];

  const [depositBonus, setDepositBonus] = useState([]);
  const [upTo, setUpToBonus] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          "https://api.betbazaar365.com/admin/getDepositBonus"
        );

        const data = response?.data;

        if (data) {
          // ✅ Fetch deposit transactions
          const depositTxnResponse = await axios.get(
            `https://api.betbazaar365.com/api/manual-deposit-all`,
            {
              params: {
                uid: parseFloat(Cookies.get("uid")),
                req_type: "deposit",
              },
            }
          );

          const depositTxn = depositTxnResponse?.data?.data || []; // Ensure it's an array

          // ✅ Map each deposit bonus and match it with transaction count
          const updatedData = data.data
            .map((bonusItem) => {
              // Count number of transactions
              const transactionCount = depositTxn.length;

              return {
                ...bonusItem,
                imgSrc: "/assets/bcimages/promotion/box1.webp",
                bgImgSrc: "/assets/bcimages/promotion/backimg1.webp",
                isDeposit: transactionCount >= bonusItem.deposit_no, // ✅ Compare with deposit_no
              };
            })
            .sort((a, b) => a.deposit_no - b.deposit_no); // ✅ Sorting in ascending order

          setDepositBonus(updatedData);
          setUpToBonus(data.data[data.data.length - 1]?.bonus_percent || 0);
        }
      } catch (error) {
        console.error("Error fetching payment depositBonus:", error);
      }
    };

    fetchSettings();
  }, []); // ✅ Runs only once

  return (
    <div>
      <h4 style={{ fontWeight: "bold" }}> Promotion </h4>

      <div className="promotions-container">
        <div className="promotion-header">
          <div className="promotion-title">
            Great Deposit Bonus in <br /> Casino or Sports
          </div>
          <div>
            <p className="promotion-main-text">
              UP TO {upTo}% <br /> Deposit
            </p>
          </div>
          <div className="flex gap-x-2" style={{ gridArea: "button" }}>
            <button className="deposit-button-inner">
              {/* <DepositUpi
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                }}
              /> */}
              <DepositUpi
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                }}
              >
                Deposit
              </DepositUpi>
            </button>
          </div>
        </div>

        {/* Dynamically Rendering Bonus Cards */}
        <div className="promotion-bonuses">
          {depositBonus?.map((promotion) => (
            <div className="bonus-card" key={promotion.rank}>
              <div>
                <img
                  className="bonus-bg-img"
                  src={promotion.bgImgSrc}
                  alt="Background"
                />
              </div>
              <img
                className="rank-icon"
                src="/assets/bcimages/promotion/rankicon.webp"
                alt="Rank Icon"
              />
              <span className="rank-number">{promotion.deposit_no}</span>
              <div className="res-bounscard">
                <img
                  style={{ order: "2" }}
                  className="bonus-img"
                  src={
                    promotion.isDeposit
                      ? promotion?.imgSrc
                      : "https://bc.app/modules/bonus2/assets/coin2_closed-4758251f.png"
                  }
                  alt={promotion.deposit_no}
                />
                <div style={{ order: "1", position: "relative" }}>
                  <h3 className="res-bounscardtext">
                    {promotion.bonus_percent}
                    {"% BONUS"}
                  </h3>
                  <p
                    style={{
                      backgroundColor: "#323738",
                      margin: "5px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="res-bounscardp"
                  >
                    {/* <DepositUpi
                      style={{
                        color: "#ccc",
                        border: "none",
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                      }}
                      
                    /> */}
                    <DepositUpi
                      readOnly
                      disabled={promotion.isDeposit} // ✅ Disable if already deposited
                      onClick={(e) => {
                        if (promotion.isDeposit) {
                          e.preventDefault(); // ✅ Prevent any action if disabled
                          e.stopPropagation(); // ✅ Stop event from bubbling
                        }
                      }}
                      style={{
                        color: "#ccc",
                        border: "none",
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                        cursor: promotion.isDeposit ? "not-allowed" : "pointer", // ✅ Change cursor if disabled
                        pointerEvents: promotion.isDeposit ? "none" : "auto", // ✅ Completely disable clicks
                      }}
                    >
                      {promotion.isDeposit
                        ? "Deposited"
                        : `${promotion.deposit_no} Deposit`}
                    </DepositUpi>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="flex gap-x-2"
          style={{ gridArea: "button", marginTop: "15px" }}
        >
          <button className="deposit-button-inner-1">
            <DepositUpi
              style={{
                color: "black",
                border: "none",
                backgroundColor: "transparent",
                fontWeight: "bold",
              }}
            />
          </button>
        </div>
      </div>

      {/* Tab Buttons for Latest and Archived Promotions */}
      {/* <div className="data-promotiion-card" style={{ display: "flex" }}>
        <div
          style={{ whiteSpace: "nowrap" }}
          className={`tab-button ${
            activeTab === "Latest Promotion" ? "active-tab" : ""
          }`}
          onClick={() => setActiveTab("Latest Promotion")}
        >
          Latest Promotion
        </div>
        <div
          className={`tab-button ${
            activeTab === "Archived" ? "active-tab" : ""
          }`}
          onClick={() => setActiveTab("Archived")}
        >
          Archived
        </div>
      </div> */}

      {activeTab === "Latest Promotion" && <CardPromotion />}
      {/* {activeTab === "Archived" && <CardArchivePromotion />} */}
    </div>
  );
}

export default Promotions;
